/**
 * @owner @Appboy/whats-app
 */
import { z } from "zod";
import { whatsAppResponseMessageCommonSchema } from "@schemas/message/whatsAppResponseMessageCommonSchema";

// Refer to WhatsAppResponseMessageCtaFlowExport
export const whatsAppResponseFlowMessageSchema = z.object({
  ...whatsAppResponseMessageCommonSchema.shape,
  layout: z.literal("cta-flow"),
  header_text: z.string().nullable().optional(),
  body: z.string().nullable().optional(),
  footer: z.string().nullable().optional(),
  cta_flow_button: z
    .object({
      caption: z.string(),
      flow_id: z.string(),
    })
    .optional(),
  generate_custom_attribute: z.boolean().optional(),
});
